import * as React from "react";
import type { SVGProps } from "react";
const SvgDuration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#duration_svg__a)">
      <path d="M4.58 16.03a1 1 0 0 1-.93-.63 9 9 0 0 1 15.38-9.08V4.03a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1h-5a1 1 0 0 1 0-2h2.78a7 7 0 0 0-12.3 6.63 1 1 0 0 1-.93 1.37M7.2 19.4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M11.03 20.97a1 1 0 1 1 0-2 1 1 0 0 1 0 2M15.14 20.4a1 1 0 1 1 0-2 1 1 0 0 1 0 2M18.41 17.87a1 1 0 1 1 0-2 1 1 0 0 1 0 2M20.03 14.03a1 1 0 1 1 0-2 1 1 0 0 1 0 2" />
      <path d="M14.03 16.03a1 1 0 0 1-.66-.25l-2-1.76a1 1 0 0 1-.34-.75V7.75a1 1 0 0 1 2 0v5.06l1.67 1.47a1 1 0 0 1-.67 1.75" />
    </g>
    <defs>
      <clipPath id="duration_svg__a">
        <path fill="#fff" d="M3 3h18.03v17.97H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDuration;
